import cn from 'classnames';
import { FC } from 'react';

import { Dialog, useDialog, ButtonTemplate } from '@catawiki/cata-style';

import { cleanBuilderStringInput, getBuilderString } from '@/shared/text';

import style from './YouTubeVideo.module.scss';

export interface YoutubeSettings {
  url: string;
  poster: string;
  disabledDialog?: boolean;
}

interface Props extends YoutubeSettings {
  locale: string;
  className?: string;
  mediaCaption?: string;
}

export const YouTubeVideo: FC<Props> = ({
  className,
  locale,
  poster,
  url,
  mediaCaption,
  disabledDialog,
}) => {
  const { isOpen, onToggle, onOpen } = useDialog();

  const youTubeId = () => {
    try {
      return new URL(getBuilderString(url, locale)).pathname.split('/').pop();
    } catch {
      return 'FViRtmXEOQA';
    }
  };

  const youtubePosterImage = cleanBuilderStringInput(
    getBuilderString(poster, locale),
    true
  );

  if (disabledDialog) {
    return (
      <div className={cn(className, style.container, style.content)}>
        <iframe
          width="100%"
          src={`https://www.youtube.com/embed/${youTubeId()}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  if (!youtubePosterImage) return null;
  return (
    <ButtonTemplate className={cn(className, style.container)} onClick={onOpen}>
      <img
        data-testid="media-youtube-image"
        className={style.image}
        alt={mediaCaption}
        src={youtubePosterImage}
      />
      <img
        alt="Play video"
        src={`/assets/pages/images/controls/video-play.svg`}
        className={style.control}
      />
      <Dialog
        className={cn(style.youtube, style.dialog)}
        open={isOpen}
        onToggle={() => onToggle()}
      >
        <div className={style.content}>
          <iframe
            width="100%"
            src={`https://www.youtube.com/embed/${youTubeId()}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <button
          className={style.close}
          onClick={(e) => {
            e.stopPropagation();
            onToggle(false);
          }}
        >
          <img
            className={style.icon}
            alt={'Close video'}
            src={`/assets/pages/images/controls/youtube-close.svg`}
          />
        </button>
      </Dialog>
    </ButtonTemplate>
  );
};
